<script lang="ts">
    import { appManager } from "../AppManagerStore";
    import { _ } from "svelte-i18n";
    import LanguageSelector from "../header/language/LanguageSelector.svelte";
    export let bgClass: string = "bg-dark";
</script>

<footer class="py-8 {bgClass}">
    <div class="container">
        <div class="row">
            <div class="col-6 col-md-4 col-lg-3">

                <p class="text-gray-700 mb-2">
                    <a
                        class="icon footer-brand img-fluid"
                        href={$appManager.PublicUrl}>
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="24"
                            width="24"
                            viewBox="0 0 24 24"
                            ><title>Stockholm-icons / Code / Github</title><desc
                                >Created with Sketch.</desc
                            ><g
                                id="ANYWAYS Logo"
                                fill="none"
                                transform="rotate(180,12,12)"
                                ><rect
                                    y="0"
                                    x="0"
                                    height="24"
                                    width="24" /><path
                                    class="primary"
                                    id="Combined-Shape"
                                    fill="#335eea"
                                    d="m3.5 4c-.2761.0-.5.2239-.5.5v5.293c0 .1326.0527.26.1465.353.1952.196.5118.196.707.0L6.043 7.957l3.6816 3.682a2.1523 2.1183.0 011.7794-1.049L7.457 6.543l1.6895-1.6895c.0938-.0938.1465-.2209.1465-.3535.0-.2761-.2239-.5-.5-.5H3.5zM13 14.293a2.1523 2.1183.0 01-1.418.529 2.1523 2.1183.0 01-.582-.08V20c0 .552.448 1 1 1s1-.448 1-1v-5.707z"
                                    transform="rotate(180 12 12)" /><path
                                    class="primary"
                                    opacity=".3"
                                    fill="#335eea"
                                    d="m7.2448 17.145 2.0017 2.0017c.093768.09377.14645.22094.14645.35355.0.27614-.22386.5-.5.5h-5.364c-.27614.0-.5-.22386-.5-.5v-5.364c0-.13261.052678-.25978.14645-.35355.19526-.19526.51184-.19526.70711.0l1.9432 1.9432 3.0284-2.5625 1.2919 1.5268z" /></g
                            ><ellipse
                                class="primary"
                                rx="2.1523"
                                ry="2.1183"
                                stroke="#335eea"
                                cy="12.61"
                                cx="11.72"
                                stroke-width="1.4226"
                                fill="none" /></svg>
                    </a>ANYWAYS
                </p>

                <p class="text-muted mb-2">
                    Pastoor Dergentlaan 70/5 <br />
                    3200 Aarschot
                </p>

                <p class="text-muted mb-2">BE 0662677175</p>

                <!-- Social -->
                <ul class="list-unstyled list-inline list-social mb-6 mb-md-0">
                    <li class="list-inline-item list-social-item mr-3">
	                    <a rel="me" href="https://urbanists.social/@anyways" class="text-decoration-none">
                            <img
                                src="{$appManager.PublicUrl}icons/social/mastodon.svg"
                                class="list-social-icon"
                                alt="..." /></a>
                    </li>
                    <li class="list-inline-item list-social-item mr-3">
                        <a
                            href="https://github.com/anyways-open/"
                            class="text-decoration-none">
                            <img
                                src="{$appManager.PublicUrl}icons/social/github.svg"
                                class="list-social-icon"
                                alt="..." />
                        </a>
                    </li>
                    <li class="list-inline-item list-social-item">
                        <a
                            href="https://www.linkedin.com/company/anywayseu"
                            class="text-decoration-none">
                            <img
                                src="{$appManager.PublicUrl}icons/social/linkedin.svg"
                                class="list-social-icon"
                                alt="..." />
                        </a>
                    </li>
                    <li class="list-inline-item list-social-item">
                        <a
                            href="https://www.youtube.com/channel/UC05_oRDffZCbk70czGrLwIQ"
                            class="text-decoration-none">
                            <img
                                src="{$appManager.PublicUrl}icons/social/youtube.svg"
                                class="list-social-icon"
                                alt="..." />
                        </a>
                    </li>
                </ul>
            </div>
            <div class="col-1">
                <LanguageSelector text="text-muted" />
            </div>
            <div class="ms-auto col-6 col-md-4 col-lg-2">
                
                <h6 class="font-weight-bold text-uppercase text-gray-700">
                    {$_("footer.usecases")}
                </h6>

                <ul class="list-unstyled text-muted mb-6 mb-md-8 mb-lg-0">
                    <li class="mb-3">
                        <a
                            href="{$appManager.PublicUrl}#tia"
                            class="text-reset">
                            {$_("menu.tia")}
                        </a>
                    </li>
                    <li class="mb-3">
                        <a
                            href="{$appManager.PublicUrl}#roadworks"
                            class="text-reset">
                            {$_("menu.roadworks")}
                        </a>
                    </li>
                    <li class="mb-3">
                        <a
                            href="{$appManager.PublicUrl}#cycling"
                            class="text-reset">
                            {$_("menu.cyclenetwork")}
                        </a>
                    </li>
                    <li class="mb-3">
                        <a
                            href="{$appManager.PublicUrl}#ltn"
                            class="text-reset">
                            {$_("menu.ltn")}
                        </a>
                    </li>
                </ul>
            </div>
            
            <div class="col-6 col-md-4 col-lg-2">
                <h6 class="font-weight-bold text-uppercase text-gray-700">
                    {$_("footer.contact")}
                </h6>

                <ul class="list-unstyled text-muted mb-0">
                    <li class="mb-3">
                        <a
                            href="{$appManager.PublicUrl}contact"
                            class="text-reset">
                            {$_("footer.getintouch")}
                        </a>
                    </li>
                    <li class="mb-3">
                        <a
                            href="{$appManager.PublicUrl}newsletter"
                            class="text-reset">
                            {$_("general.newsletter")}
                        </a>
                    </li>
                    <li class="mb-3">
                        <a
                            href="{$appManager.PublicUrl}about/"
                            class="text-reset">
                            {$_("footer.about")}
                        </a>
                    </li>
                </ul>
            </div>
            
            <div class="col-6 col-md-4 col-lg-2">
                <h6 class="font-weight-bold text-uppercase text-gray-700">
                    {$_("footer.legal")}
                </h6>

                <ul class="list-unstyled text-muted mb-0">
                    <li class="mb-3">
                        <a
                            href="{$appManager.PublicUrl}terms/"
                            class="text-reset">
                            {$_("footer.terms")}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</footer>
